import Cookies from "js-cookie";
import constants from "./constants";

export const getJwt = () => constants.client_side_storage.accessToken;
export const getIsAdmin = () => constants.client_side_storage.userDetails.is_admin;